import { render, staticRenderFns } from "./LinkMenuLinks.vue?vue&type=template&id=bc8b261a&scoped=true&"
import script from "./LinkMenuLinks.vue?vue&type=script&lang=ts&"
export * from "./LinkMenuLinks.vue?vue&type=script&lang=ts&"
import style0 from "./LinkMenuLinks.vue?vue&type=style&index=0&id=bc8b261a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8b261a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VItemGroup,VRow})
